import type {
  GeneratedPacketData,
  TerminatedPacketData,
} from '@ipfabric/utils';

export const isTerminatedPacketData = (
  packetData: GeneratedPacketData | TerminatedPacketData,
): packetData is TerminatedPacketData => 'prevEdgeIds' in packetData;
